import React, { Component } from "react";
import PropTypes from "prop-types";
import queryString from "query-string";
import { withTranslation } from "react-i18next";
import { sanitizeUrl } from "@braintree/sanitize-url";
import { withRouter } from "react-router-dom";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { setCookie, getCookies } from "../../utils/cookies";
import {
  removeAllStorageValues,
  getNestedObject,
  getLocalStorageValue,
  removeLocalStorageValue
} from "../../utils/common";
import Logo from "../../assets/images/Logo.png";
import Logoo from "../../assets/images/logo-one.svg";
import UserIcon from "../../assets/images/person-icon.svg";
import LogoutIcon from "../../assets/images/log-out-icon.svg";
import i18n from "../../i18n";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropdown: false,
      showLogout: false,
      showLanguage: false
    };
  }

  changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setCookie("ctsessionlanguage", lang);
    this.setDropdownIsShown(false);
    this.changeUrl(lang);
    this.changeLoginUrlCookie(lang);
  };

  changeUrl = (lang) => {
    const {
      location: { pathname, search },
      history
    } = this.props;
    const params = queryString.parse(search);
    if (params.language) {
      params.language = lang;
      history.push(
        sanitizeUrl(
          `${pathname}?${decodeURIComponent(queryString.stringify(params))}`
        )
      );
    }
  };

  changeLoginUrlCookie = (lang) => {
    let ctAppSource;
    const locationUrl = window.location.origin;
    if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
      ctAppSource = 'ctapproutedev';
    } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
      ctAppSource = 'ctapproutestg';
    } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
      ctAppSource = 'ctapproutedevc';
    } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
      ctAppSource = 'ctapproutepsup';    
    } else if (locationUrl.indexOf('login.ct.gov') > 0) {
      ctAppSource = 'ctapproute';
    }
    const ctapproute = getCookies(`${ctAppSource}`);
    if (ctapproute && ctapproute.includes("language")) {
      const urlArray = `?${ctapproute.split("?")[1]}`;
      const params = queryString.parse(urlArray);
      params.language = lang;
      const url = `?${decodeURIComponent(queryString.stringify(params))}`;
      //setCookie("ctapproute", url);
      setCookie(`${ctAppSource}`, url);
    }
  };

  setDropdownIsShown = (show) => {
    this.setState({
      showDropdown: show
    });
  };

  setLogoutIsShown = (show) => {
    this.setState({
      showLogout: show
    });
  };

  userLogout = () => {
    removeAllStorageValues();
    removeLocalStorageValue("isUserLogin");
    if (getLocalStorageValue("dataStoreToken")) {
      removeLocalStorageValue("dataStoreToken");
    }
    if (getLocalStorageValue("authToken")) {
      removeLocalStorageValue("authToken");
    }
    const locationUrl = window.location.origin;
    let logOutUrl;
    if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
      logOutUrl = '/openam/IDPSloInit?metaAlias=/BOSCitizens/devidp&binding=urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST&RelayState=';
    } else {
      logOutUrl = '/IDPSloInit?metaAlias=/boscitizens/devidp&binding=urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST&RelayState=';
    }
    const loginUrl = '/ctidentity/login';
    window.location.replace(sanitizeUrl(`${locationUrl}${logOutUrl}${locationUrl}${loginUrl}`));
  };

  render() {
    const {
      t,
      userDetails,
      location: { pathname }
    } = this.props;
    const { showDropdown, showLogout, showLanguage } = this.state;
    return (
      <>
        <header className="header">
          <div className="d-flex">
            <div className="d-flex header-logo-container">
              <img className="header__logo" src={Logoo} alt="Connecticut" />
              <span className="header-text uppercase">{t("common.headerText")}</span>
            </div>
            <div className="right__section">
              <Nav>
                <NavDropdown
                  id="language-dropdown"
                  onMouseEnter={() => this.setDropdownIsShown(true)}
                  onMouseLeave={() => this.setDropdownIsShown(false)}
                  onToggle={(e) => {
                    if (e) {
                      this.setDropdownIsShown(e);
                    }
                  }}
                  onClick={() => {
                    this.showLanguage = !this.showLanguage
                      this.setDropdownIsShown(this.showLanguage);
                     
                  }}
                  onBlur={(e) => {
                    const className = getNestedObject(e, [
                      "relatedTarget",
                      "className"
                    ]);
                    if (className && !className.includes("dropdown-item")) {
                      this.setDropdownIsShown(false);
                    }
                  }}
                  show={showDropdown}
                  title={t("common.language")}
                  className={`header__dropdown ${
                    userDetails.userName || pathname.includes("profile")
                      ? "hide-desktop"
                      : ""
                  } `}
                >
                  <NavDropdown.Item
                    onClick={() => this.changeLanguage("en_US")}
                  >
                    {t("common.languages.english")}
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => this.changeLanguage("es")}>
                    {t("common.languages.spanish")}
                  </NavDropdown.Item>
                </NavDropdown>
                {userDetails.userName && (
                  <NavDropdown
                    id="user-dropdown"
                    onMouseEnter={() => this.setLogoutIsShown(true)}
                    onMouseLeave={() => this.setLogoutIsShown(false)}
                    onToggle={(e) => {
                      if (e) {
                        this.setLogoutIsShown(e);
                      }
                    }}
                    show={showLogout}
                    onBlur={(e) => {
                      const className = getNestedObject(e, [
                        "relatedTarget",
                        "className"
                      ]);
                      if (className && !className.includes("dropdown-item")) {
                        this.setLogoutIsShown(false);
                      }
                    }}
                    onClick={()=>{
                      this.showLogout = !this.showLogout
                      this.setLogoutIsShown(this.showLogout)
                    }}
                    title={
                      <>
                        {t("common.hello")}
                        {userDetails.givenName}
                      </>
                    }
                    className="header__user"
                  >
                    <NavDropdown.Item
                      onClick={() => {
                        this.userLogout();
                      }}
                    >
                      {t("common.logout")}
                    </NavDropdown.Item>
                  </NavDropdown>
                )}
              </Nav>
            </div>
          </div>
        </header>
      </>
    );
  }
}

Header.propTypes = {
  t: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  userDetails: PropTypes.object
};
Header.defaultProps = {
  userDetails: {}
};
export default withTranslation()(withRouter(Header));
